<template>
    <v-card class="elevation-0">
        <v-card-text class="pa-0">
            <alert-outline>
                {{ $t('Connect_Hardware_Token_with_User') }}
            </alert-outline>
        </v-card-text>
        <v-card-text>
            <v-form v-model="isValid" @submit.prevent>
                <text-field-label
                    :id="'uid-hard'"
                    v-model="uidHard"
                    :rules="[rules.maxChars(uidHard, 256)]"
                    :label="$t('User_ID')"
                    :disabled="isProcessing"
                    :prepend-icon="'person'"
                    :name="'uid-hard'"
                    class="py-1"
                />
                <text-field-label
                    :id="'password-hard'"
                    v-model="passwordHard"
                    :rules="[rules.maxChars(passwordHard, 255)]"
                    :label="$t('Password')"
                    :disabled="isProcessing"
                    :prepend-icon="'lock'"
                    :name="'password-hard'"
                    :type="'password'"
                    class="py-1"
                />
                <text-field-label
                    :id="'serial-number'"
                    v-model="serialNumber"
                    :label="$t('Serial_Number')"
                    :hint="$t('Enter_the_serial_number_which_is_on_the_back_of_the_device')"
                    :rules="[rules.maxChars(serialNumber, 256)]"
                    :disabled="isProcessing"
                    :prepend-icon="'fa-tablet'"
                    :name="'serial-number'"
                    persistent-hint
                    class="py-1"
                    @keydown.13="submitRegister"
                />
                <checkbox v-if="domainName" v-model="isUseDomain" :disabled="isProcessing" name="user-domain">
                    <template v-slot:label>
                        <div class="text-caption text--primary" :class="`${$options.name}__OmitName`">
                            {{ domainLabel }}
                        </div>
                    </template>
                </checkbox>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <button-app-control
                :label="$t('Registration')"
                :disabled="isDisableSubmit || isProcessing || !isValid"
                @click="submitRegister"
            />
        </v-card-actions>
    </v-card>
</template>

<script lang="ts">
import { mixins } from 'vue-class-component';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { AlertOutline, ButtonAppControl, TextFieldLabel, Checkbox } from '../../atoms';
import InputValidation from '../../../mixins/InputValidation';

@Component({
    name: 'HardDeviceRegisterForm',
    components: {
        AlertOutline,
        ButtonAppControl,
        TextFieldLabel,
        Checkbox,
    },
})
export default class HardDeviceRegisterForm extends mixins(InputValidation) {
    @Prop({ default: false }) processing: boolean;
    @Prop({ default: '' }) domain: string;
    @Watch('domain', { immediate: true })
    onDomainChanged(val: string): void {
        this.isUseDomain = !!val;
    }

    uidHard = '';
    passwordHard = '';
    serialNumber = '';
    isUseDomain = false;

    /**
     * lifecycle hooks
     */
    created() {
        this.$watch(
            'uidHard',
            (newVal: string) => {
                this.uidHard = this.uidHard.toLowerCase();
            },
            {
                immediate: true,
                deep: true,
            }
        );
    }

    /**
     * getter
     */
    get isProcessing(): boolean {
        return this.processing;
    }
    get domainName(): string {
        return this.domain;
    }
    get isDisableSubmit(): boolean {
        return !this.uidHard || !this.passwordHard || !this.serialNumber || this.isProcessing || !this.isValid;
    }
    get domainLabel(): string {
        return this.isUseDomain ? this.domainName : (this as any).$t('Use_domain_user');
    }

    /**
     * methods
     */
    submitRegister(): void {
        if (!this.isDisableSubmit) {
            this.$emit('hardDeviceRegister', {
                uid: this.isUseDomain ? `${this.uidHard}@${this.domainName}` : this.uidHard,
                password: this.passwordHard,
                serial_number: this.serialNumber,
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.HardDeviceRegisterForm {
    &__OmitName {
        max-width: 15rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
</style>
